import React, { useState, useEffect, useContext } from 'react';
import {
    Radio,
    Icon,
    message,
    Button,
    Select,
    DatePicker,
    Tag,
    Modal,
} from 'antd';
import { observer } from 'mobx-react-lite';
import { useRequest } from 'ahooks';
import './index.less';
import { TableLv2 } from '../../table/level2';
import { IMemberListData } from '../../../../pages/om/member/member-list/store';
import {
    MEMBER_IDENTITY_MAP,
    detailFieldsMap,
} from '../../../../pages/om/member/member-list/index';
import moment from 'moment';
import _ from 'lodash';
import { StoreContext } from '@/stores';
import { tryNewCall } from '@/containers/hoc/call-center';
import { IMemberListStagingData } from '../../../../pages/om/member/member-list-staging/store';
import { defaultAxios } from '@/utils';
import { AntButton } from '@/components/antd';
import { CC } from '../../table/cells/cc';
import qs from 'querystring';
import CryptoJS from 'crypto-js';
import XLSX from 'xlsx';
import NewReportDrawer, { INewReportData } from './report-create';
import NewEmployerReportModal, {
    INewEmployerReportData,
} from './employer-report-create';
import RightsReportDetail from './rights-report-detail';

// 十六位十六进制数作为密钥
const SECRET_KEY = CryptoJS.enc.Utf8.parse('4123286782825529');
// 十六位十六进制数作为密钥偏移量
const SECRET_IV = CryptoJS.enc.Utf8.parse('4740443514203706');
const EMPLOYER_REPORT_API = {
    list: '/crm/report/getReputationReportTaskList',
    add: '/crm/report/addReputationReportTask',
    stop: '/crm/report/stopReputationReportTask',
};

/**
 * 加密方法
 * @param data
 * @returns {string}
 */
export function encrypt(data: string) {
    if (typeof data === 'object') {
        try {
            // eslint-disable-next-line no-param-reassign
            data = JSON.stringify(data);
        } catch (error) {
            console.log('encrypt error:', error);
        }
    }
    const dataHex = CryptoJS.enc.Utf8.parse(data);
    const encrypted = CryptoJS.AES.encrypt(dataHex, SECRET_KEY, {
        iv: SECRET_IV,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.ciphertext.toString();
}

export interface ICustomerMaiRightsProps {
    cid?: string | number;
    defaultCustomerName?: string;
    crm_id?: string | number;
}
export interface ITalentMemberData extends IMemberListData {}
export interface ITalentStagingMemberData extends IMemberListStagingData {}
export interface ITalentWorkBenchData {
    cid: string | number; // cid
    shortname: string; // 名称
    sale_type: number; // 销售类型
    auth_employee_authentication: number; // 员工认证
    auth_can_talk: number; // 员工可以聊
    auth_opinion: number;
    auth_asking: number; // 员工说
    opinion_words_num: number;
    expire_time: string;
    exposure_coins: number;
    clear_times: number;
    admin_list: {
        id: number;
        realname: string;
        mobile: string;
    }[];
}
export interface ITalentWorkUseData {
    base: {
        name: string;
        uid: number;
        position: string;
        memberStartTime: string;
        totalMemberDays: string;
        memberJoinTime: string;
        directLeft: number;
        virtualPhoneLeft: number;
        friendLeft: number;
        coinLeft: number;
    };
    active: {
        mmActiveDays: number;
        recruitmentActiveDays: number;
        activeRate: number;
    };
    findTalent: {
        totalSearchCount: number;
        totalTalentPv: number;
    };
    connection: {
        directOppoCount: number;
        directOppoReplyCount: number;
        virtualPhoneRequestCount: number;
        virtualPhoneCallCount: number;
        virtualPhoneConnectedCount: number;
        fastContactSendCount: number;
        fastContactReplyCount: number;
        friendAddRequestCount: number;
        friendAddSuccessCount: number;
    };
    jobsAndResume: {
        newJobsCount: number;
        validJobsCount: number;
        receivedResumeCount: number;
        handleResumeCount: number;
        interestResumeCount: number;
    };
}

export interface ITalentUseNewData {
    msg: string;
    result: string;
    total: number;
    code: number;
    data: any[];
    titles: {
        name: string;
        key: string;
        sub_titles: { name: string; key: string }[];
    }[];
}

const CustomerMaiRights: React.FC<ICustomerMaiRightsProps> = props => {
    const store = useContext(StoreContext);
    const memberStore = store.getDefaultMemberStore();
    const authStore = store.getAuthStore();

    const { fetchConfigData, configData } = memberStore;
    useEffect(() => {
        fetchConfigData();
    }, []);
    const [maiRightsSwitch, setMaiRightsSwitch] = useState('1'); // 1:人才银行 2:企业号
    const [talentLoading, setTalentLoading] = useState(false); // 人才银行loading
    const [talentMemberData, setTalentMemberData] = useState<any>([]);
    const [talentWorkBenchData, setTalentWorkBenchData] = useState<
        ITalentWorkBenchData[]
    >();
    const [talentTookerData, setTalentTookerData] = useState<any>();
    const [talentWorkBenchLoading, setTalentWorkBenchLoading] = useState(false);
    const [talentTookerLoading, setTalentTookerLoading] = useState(false);
    const [teamInfoData, setTeamInfoData] = useState<any[]>([]);

    // 拓客通筛选（团队维度）
    const [tktFilter, setTktFilter] = useState<{
        licenseId?: string | number;
        start?: number;
        end?: number;
    }>({
        start: moment()
            .startOf('month')
            .startOf('day')
            .valueOf(),
        end: moment()
            .endOf('month')
            .endOf('day')
            .valueOf(),
    });
    const [tktUseDataLoading, setTktUseDataLoading] = useState(false);
    const [tktUseDataOrigin, setTktUseDataOrigin] = useState<any>();
    const [tktUseDataV2Loading, setTktUseDataV2Loading] = useState(false);
    const [tktUseDataV2Origin, setTktUseDataV2Origin] = useState<any>();

    const [useDataFilter, setUseDataFilter] = useState<{
        teamAdmin?: string;
        start?: number;
        end?: number;
    }>({
        start: moment()
            .startOf('month')
            .startOf('day')
            .valueOf(),
        end: moment()
            .endOf('month')
            .endOf('day')
            .valueOf(),
    });

    const [teamAdminData, setTeamAdminData] = useState<
        {
            name: string;
            phone: number | string;
            id: string | number;
            admin_uid: number;
        }[]
    >([]);
    const [useDataLoading, setUseDataLoading] = useState(false);
    const [useDataOrigin, setUseDataOrigin] = useState<any>([]);

    const [useNewDataOrigin, setUseNewDataOrigin] = useState<
        ITalentUseNewData
    >();
    const [useDataPagination, setUseDataPagination] = useState({
        pageSize: 20,
        current: 1,
    });

    // 新增报告drawer状态
    const [newReportDrawerVisible, setNewReportDrawerVisible] = useState(false);
    const [newReportLoading, setNewReportLoading] = useState(false);
    const [reportCopySeed, setReportCopySeed] = useState<Partial<
        INewReportData
    > | null>(null);
    const [newEmployerReportVisible, setNewEmployerReportVisible] = useState(
        false,
    );
    const [newEmployerReportLoading, setNewEmployerReportLoading] = useState(
        false,
    );

    const openNewReportDrawer = (
        seed: Partial<INewReportData> | null = null,
    ) => {
        setReportCopySeed(seed);
        setNewReportDrawerVisible(true);
    };

    const handleNewReportDrawerClose = () => {
        setNewReportDrawerVisible(false);
        setReportCopySeed(null);
    };

    const openNewEmployerReportModal = () => {
        setNewEmployerReportVisible(true);
    };

    const closeNewEmployerReportModal = () => {
        setNewEmployerReportVisible(false);
    };

    // 白名单逻辑已移除，报告功能不再受白名单限制

    // const fetchUseData = async () => {
    //     const url = '/crm/equity/getTeamUserData';
    //     setUseDataLoading(true);
    //     const [d, e] = await defaultAxios.get(
    //         url,
    //         {
    //             // ...useDataFilter,
    //             start_time: useDataFilter.start,
    //             end_time: useDataFilter.end,
    //             cid: useDataFilter.teamAdmin,
    //         },
    //         {
    //             timeout: 400000,
    //         },
    //     );
    //     setUseDataLoading(false);
    //     if (d === null || d.data === null) {
    //         message.error('查询失败～');
    //         return [null, e];
    //     }
    //     const data = d.data;
    //     if (data && Array.isArray(data?.item)) {
    //         setUseDataOrigin(data.item);
    //     } else {
    //         setUseDataOrigin([]);
    //         message.error(data?.msg || '查询失败～');
    //     }
    // };

    const fetchUseNewData = async () => {
        const url = '/crm/equity/getTeamUseNewData';
        setUseDataLoading(true);
        const [d, e] = await defaultAxios.get(
            url,
            {
                start_time: moment(useDataFilter.start).format('YYYY-MM-DD'),
                end_time: moment(useDataFilter.end).format('YYYY-MM-DD'),

                co_id: useDataFilter.teamAdmin,
                admin_uid: teamAdminData.find(
                    item => item.id === useDataFilter.teamAdmin,
                )?.admin_uid,
                page: useDataPagination.current - 1,
                size: useDataPagination.pageSize,
            },
            {
                timeout: 400000,
            },
        );
        setUseDataLoading(false);
        if (d === null || d.data === null) {
            message.error('查询失败～');
            return [null, e];
        }
        const data = d.data;
        setUseNewDataOrigin(data);
    };

    const {
        data: customerRaskList = [],
        loading: customerRaskListLoading,
        refreshAsync: refreshCustomerRaskListAsync,
    } = useRequest(
        async () => {
            const [d, e] = await defaultAxios.get(
                '/crm/report/getCustomerRaskList',
                {
                    cid: props.cid,
                    uid: 62913,
                    page: 0,
                    count: 9999,
                },
            );
            return d?.data || {};
        },
        {
            ready: maiRightsSwitch == '1',
            refreshDeps: [props.cid, maiRightsSwitch],
        },
    );

    const {
        data: employerReportList = [],
        loading: employerReportListLoading,
        refreshAsync: refreshEmployerReportListAsync,
    } = useRequest(
        async () => {
            const [d] = await defaultAxios.get(EMPLOYER_REPORT_API.list, {
                cid: props.cid,
                uid: 62913,
                page: 0,
                count: 9999,
            });
            return d?.data || [];
        },
        {
            ready: maiRightsSwitch == '2',
            refreshDeps: [props.cid, maiRightsSwitch],
        },
    );

    // 已移除获取白名单配置的请求

    // const exportUseData = () => {
    //     const exportUrl = `/bff/api/rest/member-list/export-use-data?cid=${useDataFilter.teamAdmin}&start_time=${useDataFilter.start}&end_time=${useDataFilter.end}`;
    //     window.open(exportUrl, '_blank');
    // };

    const toStringArray = (
        value: any,
        splitter: RegExp = /[,，、\s]+/,
    ): string[] => {
        if (value === null || value === undefined) {
            return [];
        }
        if (Array.isArray(value)) {
            return value.map(item => String(item).trim()).filter(Boolean);
        }
        if (typeof value === 'string') {
            return value
                .split(splitter)
                .map(item => item.trim())
                .filter(Boolean);
        }
        if (typeof value === 'number') {
            return [String(value)];
        }
        return [];
    };

    const parseMomentValue = (value: any) => {
        if (!value) {
            return undefined;
        }
        const parsed = moment(value);
        return parsed.isValid() ? parsed : undefined;
    };

    const parseLinkedPositionField = (
        value: any,
        positionCount: number,
    ): string[] => {
        const size = positionCount > 0 ? positionCount : 0;
        if (!size) {
            return [];
        }

        const normalizeCell = (cell: any): string => {
            if (cell === null || cell === undefined) {
                return '';
            }
            if (typeof cell === 'string') {
                return cell
                    .split(',')
                    .map(item => item.trim())
                    .filter(Boolean)
                    .join(',');
            }
            if (typeof cell === 'number') {
                return String(cell).trim();
            }
            return '';
        };

        if (Array.isArray(value)) {
            return Array.from({ length: size }, (_, i) =>
                normalizeCell(value[i]),
            );
        }

        if (typeof value === 'string') {
            const segments = value.split(';');
            return Array.from({ length: size }, (_, i) =>
                normalizeCell(segments[i]),
            );
        }

        if (typeof value === 'number') {
            return Array.from({ length: size }, (_, i) =>
                i === 0 ? String(value).trim() : '',
            );
        }

        return Array.from({ length: size }, () => '');
    };

    const buildReportCopySeed = (
        record: any,
    ): Partial<INewReportData> | null => {
        if (!record || typeof record !== 'object') {
            return null;
        }

        const reviewStart = parseMomentValue(record.start_date);
        const reviewEnd = parseMomentValue(record.end_date);
        const comparisonStart = parseMomentValue(record.cmp_start_date);
        const comparisonEnd = parseMomentValue(record.cmp_end_date);

        const positions = toStringArray(record.position_names).slice(0, 3);
        const positionCount = positions.length;

        return {
            reviewCompanyTeam: record.co_ids?.split(',')?.map(Number),
            reviewTimePeriod: [reviewStart, reviewEnd] as any,
            comparisonTimePeriod: [comparisonStart, comparisonEnd] as any,
            competitorCompanyCids: Array.from(
                { length: 5 },
                (_, i) => toStringArray(record.cmp_cids)[i] || '',
            ),
            positions,
            positionCities: parseLinkedPositionField(
                record.position_cities,
                positionCount,
            ),
            positionProfessions: parseLinkedPositionField(
                record.position_professions,
                positionCount,
            ),
        };
    };

    const handleCopyReport = (record: any) => {
        const seed = buildReportCopySeed(record);
        openNewReportDrawer(seed);
    };

    // 处理新增报告提交
    const handleNewReportSubmit = async (data: INewReportData) => {
        setNewReportLoading(true);
        try {
            const selectedTeamIds = (data.reviewCompanyTeam || []).map(id =>
                String(id),
            );
            const selectedTeamNames = data.reviewCompanyTeamNames || [];
            const userName =
                authStore?.userInfo?.userName ||
                authStore?.userInfo?.sysUser?.name ||
                '';
            const teamName = authStore?.userInfo?.userDept || '';
            const operatorValue = teamName
                ? `${teamName}-${userName}`
                : userName;
            const params = {
                reportName: data.reportName,
                cid: props.cid,
                coIds: selectedTeamIds.join(','),
                coNames: selectedTeamNames.join(','),
                startDate: data.reviewTimePeriod?.[0]?.format('YYYY-MM-DD'),
                endDate: data.reviewTimePeriod?.[1]?.format('YYYY-MM-DD'),
                cmpStartDate: data.comparisonTimePeriod?.[0]?.format(
                    'YYYY-MM-DD',
                ),
                cmpEndDate: data.comparisonTimePeriod?.[1]?.format(
                    'YYYY-MM-DD',
                ),
                cmpCids: data.competitorCompanyCids
                    ?.map(cid => cid.trim())
                    .filter(Boolean)
                    .join(','),
                positionNames: data.positions
                    ?.map(position => position.trim())
                    .filter(Boolean)
                    .join(','),
                positionCities: data.positionCities?.join(';'),
                positionProfessions: data.positionProfessions?.join(';'),
                operator: operatorValue,
            };

            const [resp, error] = await defaultAxios.get(
                '/crm/report/addCustomerRask',
                params,
            );

            if (!resp || error) {
                if (!error) {
                    message.error(resp?.msg || '报告任务创建失败，请稍后重试');
                }
                return false;
            }

            if (resp.data === false) {
                message.error(resp?.msg || '报告任务创建失败，请稍后重试');
                return false;
            }

            message.success('报告任务创建成功');
            handleNewReportDrawerClose();
            await refreshCustomerRaskListAsync?.();
            return true;
        } catch (error) {
            message.error('报告任务创建失败，请稍后重试');
            return false;
        } finally {
            setNewReportLoading(false);
        }
    };

    const handleStopCustomerTask = (task: any) => {
        Modal.confirm({
            title: '确认终止该任务？',
            content: '终止后将无法恢复，请确认是否继续操作。',
            okText: '确认终止',
            cancelText: '取消',
            onOk: async () => {
                const [resp, error] = await defaultAxios.get(
                    '/crm/report/stopCustomerRask',
                    {
                        uid: 62913,
                        taskId: task?.id,
                    },
                );
                if (!resp || error || resp.data === false) {
                    if (!error) {
                        message.error(resp?.msg || '任务终止失败，请稍后重试');
                    }
                    return;
                }
                message.success('任务终止成功');
                await refreshCustomerRaskListAsync?.();
            },
        });
    };

    const pickValue = (record: any, keys: string[]) => {
        for (const key of keys) {
            const value = record?.[key];
            if (value !== null && value !== undefined && value !== '') {
                return value;
            }
        }
        return undefined;
    };

    // task_status: 0-已创建; 1-生成中; 2-生成完成; 3-生成失败; 4-已终止
    const getEmployerTaskStatusMeta = (statusValue: any) => {
        const num =
            typeof statusValue === 'number'
                ? statusValue
                : Number.isNaN(Number(statusValue))
                ? null
                : Number(statusValue);
        if (num === 0) {
            return { text: '已创建', color: undefined, code: 'created' };
        }
        if (num === 1) {
            return { text: '生成中', color: 'blue', code: 'running' };
        }
        if (num === 2) {
            return { text: '生成完成', color: 'green', code: 'completed' };
        }
        if (num === 3) {
            return { text: '生成失败', color: 'red', code: 'failed' };
        }
        if (num === 4) {
            return { text: '已终止', color: 'orange', code: 'terminated' };
        }
        return { text: '生成中', color: 'blue', code: 'running' };
    };

    const handleNewEmployerReportSubmit = async (
        data: INewEmployerReportData,
    ) => {
        setNewEmployerReportLoading(true);
        try {
            const userName =
                authStore?.userInfo?.userName ||
                authStore?.userInfo?.sysUser?.name ||
                '';
            const teamName = authStore?.userInfo?.userDept || '';
            const operatorValue = teamName
                ? `${teamName}-${userName}`
                : userName;
            const validCompetitors = (data.competitors || [])
                .map(item => ({
                    cid: Number(String(item?.cid || '').trim()),
                    keyword: String(item?.keyword || '').trim(),
                }))
                .filter(item => item.cid && item.keyword);

            const params: Record<string, any> = {
                uid: 62913,
                cid: props.cid,
                reportName: data.reportName,
                operator: operatorValue,
                enterpriseName: props.defaultCustomerName || '',
                startDate: data.reviewTimePeriod?.[0]?.format('YYYY-MM-DD'),
                endDate: data.reviewTimePeriod?.[1]?.format('YYYY-MM-DD'),
                keywords: data.reviewCompanyKeywords || undefined,
                cmpStartDate:
                    data.comparisonTimePeriod?.[0]?.format('YYYY-MM-DD') ||
                    undefined,
                cmpEndDate:
                    data.comparisonTimePeriod?.[1]?.format('YYYY-MM-DD') ||
                    undefined,
                cmpCompanyInfos:
                    validCompetitors.length > 0
                        ? JSON.stringify(validCompetitors)
                        : undefined,
            };

            const [resp, error] = await defaultAxios.get(
                EMPLOYER_REPORT_API.add,
                params,
            );
            if (!resp || error || resp.data === false) {
                if (!error) {
                    message.error(resp?.msg || '报告任务创建失败，请稍后重试');
                }
                return false;
            }

            message.success('报告任务创建成功');
            closeNewEmployerReportModal();
            await refreshEmployerReportListAsync?.();
            return true;
        } catch (error) {
            message.error('报告任务创建失败，请稍后重试');
            return false;
        } finally {
            setNewEmployerReportLoading(false);
        }
    };

    const handleStopEmployerTask = (task: any) => {
        Modal.confirm({
            title: '确认终止该任务？',
            content: '终止后将无法恢复，请确认是否继续操作。',
            okText: '确认终止',
            cancelText: '取消',
            onOk: async () => {
                const [resp, error] = await defaultAxios.get(
                    EMPLOYER_REPORT_API.stop,
                    {
                        uid: 62913,
                        taskId: task?.id,
                    },
                );
                if (!resp || error || resp.data === false) {
                    if (!error) {
                        message.error(resp?.msg || '任务终止失败，请稍后重试');
                    }
                    return;
                }
                message.success('任务终止成功');
                await refreshEmployerReportListAsync?.();
            },
        });
    };

    const exportUseNewData = () => {
        const exportUrl = `/bff/api/rest/member-list/export-use-new-data?${qs.stringify(
            {
                start_time: moment(useDataFilter.start).format('YYYY-MM-DD'),
                end_time: moment(useDataFilter.end).format('YYYY-MM-DD'),
                co_id: useDataFilter.teamAdmin,
                admin_uid: teamAdminData.find(
                    item => item.id === useDataFilter.teamAdmin,
                )?.admin_uid,
                // page: useDataPagination.current - 1,
                // size: useDataPagination.pageSize,
                page: 0,
                size: 99999,
            },
        )}`;
        window.open(exportUrl, '_blank');
    };

    useEffect(() => {
        if (useDataFilter.teamAdmin) {
            // fetchUseData();
            fetchUseNewData();
        }
    }, [useDataFilter]);

    // 翻页
    useEffect(() => {
        if (useDataFilter.teamAdmin) {
            fetchUseNewData();
        }
    }, [useDataPagination]);

    const fetchCustomerRights = async () => {
        if (!props.cid) {
            return;
        }
        setTalentLoading(true);

        //
        const url = '/bff/api/rest/member-list/customer-member-list';
        const [d, e] = await defaultAxios.post(
            url,
            {
                cid: props.cid,
                customerId: props.crm_id,
            },
            {
                timeout: 400000,
            },
        );
        setTalentLoading(false);
        if (d === null || d.data === null) {
            message.error('查询失败～');
            return [null, e];
        }
        const data = d.data;
        if (data && Array.isArray(data.data)) {
            setTalentMemberData(data.data);
            setTeamAdminData(
                _.map(data.data, item => {
                    return {
                        name: item.adm_name,
                        phone: item.adm_mobile,
                        id: item.id,
                        admin_uid: item.adm_uid,
                    };
                }),
            );
            setUseDataFilter({
                ...useDataFilter,
                teamAdmin: data.data?.[0] ? data.data?.[0].id : undefined,
            });
        } else {
            setTalentMemberData([]);
            message.error(data?.msg || '查询失败～');
        }
    };
    const fetchWorkBenchData = async () => {
        if (!props.cid) {
            return;
        }
        setTalentWorkBenchLoading(true);
        const url = '/bff/api/rest/member-list/customer-work-bench-list';
        const [d, e] = await defaultAxios.post(
            url,
            {
                cid: props.cid,
            },
            {
                timeout: 400000,
            },
        );
        setTalentWorkBenchLoading(false);
        if (d === null || d.data === null) {
            message.error('查询失败～');
            return [null, e];
        }
        const data = d.data;
        if (data && !data.msg) {
            setTalentWorkBenchData([data]);
        } else {
            setTalentWorkBenchData([]);
            message.error(data?.msg || '查询失败～');
        }
    };

    const fetchTookerData = async () => {
        if (!props.cid) {
            return;
        }
        setTalentTookerLoading(true);
        const url = '/crm/member/tuoketong/list';
        const [d, e] = await defaultAxios.get(
            url,
            {
                cid: props.cid,
            },
            {
                timeout: 400000,
            },
        );

        setTalentTookerLoading(false);
        if (d === null || d.data === null) {
            message.error('查询失败～');
            return [null, e];
        }
        const data = d.data;
        if (data && !data.msg) {
            setTalentTookerData(data);
        } else {
            setTalentTookerData([]);
            message.error(data?.msg || '查询失败～');
        }
    };
    // useEffect(() => {
    //     if (props.cid) {
    //         if(maiRightsSwitch == '1') {
    //             fetchCustomerRights();
    //         } else {
    //             fetchWorkBenchData();
    //         }
    //     }
    // }, [props.cid]);
    useEffect(() => {
        if (maiRightsSwitch == '1') {
            fetchCustomerRights();
        }
        if (maiRightsSwitch === '2') {
            fetchWorkBenchData();
        }
        if (maiRightsSwitch === '3') {
            fetchTookerData();
        }
    }, [maiRightsSwitch]);

    const fetchAllTeamInfo = async () => {
        if (!talentTookerData || !Array.isArray(talentTookerData)) {
            return;
        }

        const teams = talentTookerData.flatMap((team: any) =>
            team.admins?.map?.((admin: any) => ({
                ...admin,
                license_id: team.license_id,
            })),
        );

        console.log('所有团队信息:', teams);
        setTeamInfoData(teams);
    };

    useEffect(() => {
        if (
            talentTookerData &&
            Array.isArray(talentTookerData) &&
            talentTookerData.length > 0
        ) {
            fetchAllTeamInfo();
        }
    }, [talentTookerData]);
    // teamInfoData 准备好后，默认选中第一个 license
    useEffect(() => {
        if (
            maiRightsSwitch === '3' &&
            teamInfoData &&
            teamInfoData.length > 0
        ) {
            setTktFilter(prev => ({
                ...prev,
                licenseId: prev.licenseId || teamInfoData[0]?.license_id,
            }));
        }
    }, [maiRightsSwitch, teamInfoData]);

    // 查询拓客通-团队使用数据
    const fetchTktUseNewData = async () => {
        if (!props.cid || !tktFilter.licenseId) {
            return;
        }
        const url = '/crm/member/tuoketong/getTeamUseNewData';
        setTktUseDataLoading(true);
        const [d, e] = await defaultAxios.get(
            url,
            {
                cid: props.cid,
                license_id: tktFilter.licenseId,
                start_time: moment(tktFilter.start).format('YYYY-MM-DD'),
                end_time: moment(tktFilter.end).format('YYYY-MM-DD'),
                page: 0,
                size: 99999,
            },
            {
                timeout: 400000,
            },
        );
        setTktUseDataLoading(false);
        if (d === null || d.data === null) {
            message.error('查询失败～');
            return [null, e];
        }
        setTktUseDataOrigin(d.data);
    };

    const fetchTktUseDataV2 = async () => {
        if (!props.cid || !tktFilter.licenseId) {
            return;
        }
        setTktUseDataV2Loading(true);
        const [response, error] = await defaultAxios.get(
            '/crm/member/tuoketong/getTeamUseNewDataV2',
            {
                cid: props.cid,
                license_id: tktFilter.licenseId,
                start_time: moment(tktFilter.start).format('YYYY-MM-DD'),
                end_time: moment(tktFilter.end).format('YYYY-MM-DD'),
                page: 0,
                size: 99999,
            },
            {
                timeout: 400000,
            },
        );
        setTktUseDataV2Loading(false);
        if (response === null || response.data === null) {
            message.error('V2 数据查询失败～');
            return [null, error];
        }
        setTktUseDataV2Origin({
            ...response.data,
            data: (response.data?.data || []).map((row: any) => ({
                ...row,
                id: row['席位ID'],
            })),
        });
    };

    const exportTktUseNewDataXlsx = (payload: any) => {
        const titles = (payload?.titles as any[]) || [];
        const rows = (payload?.data as any[]) || [];
        if (!Array.isArray(rows) || rows.length === 0) {
            message.warning('暂无可导出的数据');
            return;
        }

        const flatColumns: Array<{
            groupName: string;
            groupKey: string;
            subName: string;
            subKey: string;
        }> = [];
        const merges: any[] = [];
        let colCursor = 0;

        titles.forEach(group => {
            const groupName = group?.name || '';
            const groupKey = group?.key || '';
            const subTitles = group?.sub_titles || [];

            const groupStart = colCursor;
            subTitles.forEach((sub: any) => {
                flatColumns.push({
                    groupName,
                    groupKey,
                    subName: sub?.name || '',
                    subKey: sub?.key || '',
                });
                colCursor += 1;
            });
            const groupEnd = colCursor - 1;
            if (groupEnd >= groupStart) {
                merges.push({
                    s: { r: 0, c: groupStart },
                    e: { r: 0, c: groupEnd },
                });
            }
        });

        const headerRow1 = flatColumns.map(c => c.groupName);
        const headerRow2 = flatColumns.map(c => c.subName);

        const dataRows = rows.map(r =>
            flatColumns.map(col => {
                const nested = _.get(r, `${col.groupKey}.${col.subKey}`);
                const camelKey = _.camelCase(col.subKey);
                const value =
                    nested ??
                    r[col.subKey] ??
                    r[camelKey] ??
                    _.get(r, `${col.groupKey}.${camelKey}`);
                if (value === null || value === undefined) {
                    return '';
                }
                return typeof value === 'object'
                    ? JSON.stringify(value)
                    : value;
            }),
        );

        const aoa = [headerRow1, headerRow2, ...dataRows];
        const ws = XLSX.utils.aoa_to_sheet(aoa);
        ws['!merges'] = merges;

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'data');

        const startStr = moment(tktFilter.start).format('YYYYMMDD');
        const endStr = moment(tktFilter.end).format('YYYYMMDD');
        const filename = `拓客通团队使用数据_${tktFilter.licenseId}_${startStr}-${endStr}.xlsx`;

        XLSX.writeFile(wb, filename, {
            bookType: 'xlsx',
        });
    };

    const exportTktUseDataV2Xlsx = (payload: any) => {
        const titles = (payload?.titles as any[]) || [];
        const rows = (payload?.data as any[]) || [];
        if (rows.length === 0) {
            message.warning('暂无可导出的 V2 数据');
            return;
        }
        const columns = titles.map(title => ({
            header: title.name,
            key: title.key,
        }));
        const data = rows.map(row =>
            columns.reduce((result: any, column) => {
                result[column.key] = row[column.key] ?? '';
                return result;
            }, {}),
        );
        const worksheet = XLSX.utils.json_to_sheet(data, {
            header: columns.map(column => column.key),
        });
        columns.forEach((column, index) => {
            const address = XLSX.utils.encode_cell({ r: 0, c: index });
            if (worksheet[address]) {
                worksheet[address].v = column.header;
            }
        });
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'data');
        const startStr = moment(tktFilter.start).format('YYYYMMDD');
        const endStr = moment(tktFilter.end).format('YYYYMMDD');
        const filename = `拓客通团队使用数据V2_${tktFilter.licenseId}_${startStr}-${endStr}.xlsx`;
        XLSX.writeFile(workbook, filename, { bookType: 'xlsx' });
    };

    // 拓客通筛选变更时自动查询
    useEffect(() => {
        if (maiRightsSwitch === '3' && tktFilter.licenseId) {
            fetchTktUseNewData();
            fetchTktUseDataV2();
        }
    }, [maiRightsSwitch, tktFilter]);
    const renderMemberListTable = () => {
        const renderItemDetail = (
            fields: {
                field: string;
                label: string;
                suffix?: string;
                // tslint:disable-next-line:align
            }[],
            values: any,
        ) => {
            return (
                <div className="flex-column">
                    {fields.map(item => (
                        <span style={{ marginBottom: '6px' }} key={item.field}>
                            <span
                                style={{ width: '60px' }}
                                className="color-dilution no-break display-inline-block"
                            >
                                {item.label}:
                            </span>
                            <span className="no-break">
                                {`${values[item.field] || '- -'}${item.suffix ||
                                    ''}`}
                            </span>
                        </span>
                    ))}
                </div>
            );
        };
        const isStaging = talentMemberData.length
            ? talentMemberData[0].co_identity == 7
                ? true
                : false
            : false;
        return isStaging ? (
            <TableLv2<ITalentStagingMemberData>
                className={'talent-member-data-table'}
                loading={talentLoading}
                dataSource={talentMemberData}
                closeRowSelection={true}
                pagination={false}
                scroll={{ x: '2000', y: '500' }}
                columns={[
                    // {
                    //     title: '简称',
                    //     key: 'co_short_name',
                    //     dataIndex: 'co_short_name',
                    //     width: '160px',
                    // },
                    // {
                    //     title: '销售',
                    //     key: 'bd_name',
                    //     width: '80px',
                    //     dataIndex: 'bd_name',
                    // },
                    {
                        title: '账号类型',
                        dataIndex: 'co_identity',
                        key: 'co_identity',
                        width: '80px',
                        render: (
                            text: string,
                            row: ITalentStagingMemberData,
                            index: number,
                        ) => {
                            return MEMBER_IDENTITY_MAP?.[text]
                                ? MEMBER_IDENTITY_MAP?.[text]
                                : null;
                        },
                    },
                    {
                        title: '人才库版本',
                        dataIndex: 'talent_lib_version',
                        width: 100,
                        render: d => {
                            const { talent_lib_version } = configData;
                            if (
                                talent_lib_version &&
                                talent_lib_version.length
                            ) {
                                return (
                                    _.find(talent_lib_version, v => {
                                        return v.id === d;
                                    })?.name || ''
                                );
                            }
                        },
                    },
                    {
                        title: '团队名称',
                        dataIndex: 'team_name',
                        key: 'team_name',
                        width: '120px',
                    },
                    {
                        title: '管理员',
                        key: 'adm_name',
                        dataIndex: 'adm_name',
                        width: '120px',
                        render: (
                            text: string,
                            row: ITalentStagingMemberData,
                            index: number,
                        ) => {
                            const accountType =
                                MEMBER_IDENTITY_MAP?.[row?.co_identity];
                            const isV4 = accountType === 'v4.1';
                            const enterpriseParams = {
                                uid: encrypt(row?.adm_uid),
                                co_id: encrypt(row?.id.toString()),
                                mbr_co_crtime: row?.cr_time,
                                crm_uid: encrypt(
                                    String(authStore?.userInfo?.userId),
                                ),
                            };
                            return (
                                <span className="flex-column">
                                    <span className="np-break">{text}</span>
                                    <span className="np-break">
                                        {row.adm_mobile}
                                        {row.adm_mobile ? (
                                            <Icon
                                                onClick={() => {
                                                    tryNewCall(
                                                        row.adm_mobile as string,
                                                        true,
                                                        {
                                                            customerName:
                                                                props.defaultCustomerName,
                                                            customerId:
                                                                props.crm_id,
                                                            showFollowLog: true,
                                                        },
                                                    );
                                                }}
                                                style={{ cursor: 'pointer' }}
                                                type="phone"
                                                theme="twoTone"
                                                twoToneColor="#0052ff"
                                            />
                                        ) : null}
                                    </span>
                                    {isV4 && (
                                        <span className="np-break">
                                            <Button
                                                size="small"
                                                type="link"
                                                onClick={() => {
                                                    window.open(
                                                        `https://enterprise.in.taou.com/ent/v41/data?${qs.stringify(
                                                            enterpriseParams,
                                                        )}`,
                                                        '_blank',
                                                    );
                                                }}
                                            >
                                                登录人才银行
                                            </Button>
                                        </span>
                                    )}
                                </span>
                            );
                        },
                    },
                    {
                        title: '会员到期日',
                        key: 'mbr_end_time',
                        dataIndex: 'mbr_end_time',
                        width: '120px',
                        render: v => {
                            return v ? moment(v).format('YYYY-MM-DD') : null;
                        },
                    },
                    {
                        title: '招聘席位数',
                        key: 'talent_seat_num',
                        render: (v, item) => {
                            return renderItemDetail(
                                detailFieldsMap.talentSeatNum,
                                item,
                            );
                        },
                    },
                    {
                        title: '用人经理席位数',
                        key: 'depart_seat_num',
                        render: (v, item) => {
                            return renderItemDetail(
                                detailFieldsMap.departSeatNum,
                                item,
                            );
                        },
                    },
                    {
                        title: '子管理员数',
                        key: 'child_admin_num',
                        render: (v, item) => {
                            return renderItemDetail(
                                detailFieldsMap.childAdminNum,
                                item,
                            );
                        },
                    },
                    {
                        title: '立即沟通（团队）',
                        key: 'direct_oppo_left',
                        dataIndex: 'direct_oppo_left',
                    },
                    {
                        title: '虚拟电话（团队）',
                        key: 'reach_nbr_new_left',
                        dataIndex: 'reach_nbr_new_left',
                    },
                    {
                        title: '立即沟通(月配额)',
                        dataIndex: 'direct_oppo_monthly',
                        key: 'direct_oppo_monthly',
                        width: 150,
                    },
                    {
                        title: '加好友(月配额)',
                        dataIndex: 'add_fr_monthly',
                        key: 'add_fr_monthly',
                        width: 150,
                    },
                ]}
            />
        ) : (
            <TableLv2<ITalentMemberData>
                className={'talent-member-data-table'}
                loading={talentLoading}
                dataSource={talentMemberData}
                closeRowSelection={true}
                pagination={false}
                // pagination={{
                //     ...defaultMemberListPagination.paginationForUI,
                //     total: defaultMemberListPagination.amount,
                //     showSizeChanger: false,
                // }}
                // onPaginationChange={
                //     defaultMemberListPagination.setPaginationByUI
                // }
                scroll={{ x: '2300', y: '400' }}
                isFixedActions={false}
                columns={[
                    // {
                    //     title: '简称',
                    //     key: 'co_short_name',
                    //     dataIndex: 'co_short_name',
                    //     width: '160px',
                    // },
                    // {
                    //     title: '销售',
                    //     key: 'bd_name',
                    //     width: '80px',
                    //     dataIndex: 'bd_name',
                    // },
                    {
                        title: '账号类型',
                        dataIndex: 'co_identity',
                        key: 'co_identity',
                        width: '80px',
                        render: (
                            text: string,
                            row: IMemberListData,
                            index: number,
                        ) => {
                            return MEMBER_IDENTITY_MAP?.[text]
                                ? MEMBER_IDENTITY_MAP?.[text]
                                : null;
                        },
                    },
                    {
                        title: '管理员',
                        key: 'adm_name',
                        dataIndex: 'adm_name',
                        width: '120px',
                        render: (
                            text: string,
                            row: IMemberListData,
                            index: number,
                        ) => {
                            const accountType =
                                MEMBER_IDENTITY_MAP?.[row?.co_identity];
                            const isV4 = accountType === 'v4.1';
                            const enterpriseParams = {
                                uid: encrypt(row?.adm_uid),
                                co_id: encrypt(row?.id),
                                mbr_co_crtime: row?.cr_time,
                                crm_uid: encrypt(
                                    String(authStore?.userInfo?.userId),
                                ),
                            };

                            return (
                                <span className="flex-column">
                                    <span className="np-break">{text}</span>
                                    <span className="np-break">
                                        {row.adm_mobile}
                                        {row.adm_mobile ? (
                                            <Icon
                                                onClick={() => {
                                                    tryNewCall(
                                                        row.adm_mobile as string,
                                                        true,
                                                        {
                                                            customerName:
                                                                props.defaultCustomerName,
                                                            customerId:
                                                                props.crm_id,
                                                            userName:
                                                                row.adm_name,
                                                            showFollowLog: true,
                                                        },
                                                    );
                                                }}
                                                style={{ cursor: 'pointer' }}
                                                type="phone"
                                                theme="twoTone"
                                                twoToneColor="#0052ff"
                                            />
                                        ) : null}
                                    </span>

                                    {isV4 && (
                                        <span className="np-break">
                                            <Button
                                                size="small"
                                                type="link"
                                                onClick={() => {
                                                    window.open(
                                                        `https://enterprise.in.taou.com/ent/v41/data?${qs.stringify(
                                                            enterpriseParams,
                                                        )}`,
                                                        '_blank',
                                                    );
                                                }}
                                            >
                                                登录人才银行
                                            </Button>
                                        </span>
                                    )}
                                </span>
                            );
                        },
                    },
                    {
                        title: '会员到期日',
                        key: 'mbr_end_time',
                        dataIndex: 'mbr_end_time',
                        width: '120px',
                        render: v => {
                            return v ? moment(v).format('YYYY-MM-DD') : null;
                        },
                    },
                    {
                        title: '账号数',
                        dataIndex: 'license_nbr',
                        key: 'license_nbr',
                        width: '100px',
                        render: (v, item) => {
                            return v;
                        },
                    },
                    {
                        title: '总点数',
                        key: 'mm_coin_balance_total',
                        dataIndex: 'mm_coin_balance_total',
                        width: '80px',
                    },
                    {
                        title: '剩余点数',
                        dataIndex: 'mm_coin_balance_left',
                        key: 'mm_coin_balance_left',
                        width: '80px',
                    },
                    {
                        title: '加好友',
                        dataIndex: 'addfr_exchange',
                        width: '120px',
                        render: (v, item) => {
                            return renderItemDetail(
                                detailFieldsMap.addFr,
                                item,
                            );
                        },
                    },
                    {
                        title: '极速联系',
                        dataIndex: 'uh_exchange',
                        width: '120px',
                        render: (v, item) => {
                            return renderItemDetail(detailFieldsMap.uh, item);
                        },
                    },
                    {
                        title: '极速曝光',
                        dataIndex: 'exposure',
                        width: '120px',
                        render: (v, item) => {
                            return renderItemDetail(
                                detailFieldsMap.exposure,
                                item,
                            );
                        },
                    },
                    {
                        title: '团队剩余AI券的数量',
                        key: 'ai_ticket_v2_num',
                        dataIndex: 'ai_ticket_v2_num',
                        width: 150,
                    },
                    {
                        title: '团队购买的AI券的总数量',
                        key: 'ai_ticket_v2_purchase_num',
                        dataIndex: 'ai_ticket_v2_purchase_num',
                        width: 170,
                    },
                    {
                        title: '团队超级曝光余额',
                        key: 'super_exposure',
                        dataIndex: 'super_exposure',
                        width: '120px',
                    },
                    {
                        title: '人才库版本',
                        dataIndex: 'talent_lib_version',
                        width: 100,
                        render: d => {
                            const { talent_lib_version } = configData;
                            if (
                                talent_lib_version &&
                                talent_lib_version.length
                            ) {
                                return (
                                    _.find(talent_lib_version, v => {
                                        return v.id === d;
                                    })?.name || ''
                                );
                            }
                        },
                    },
                    {
                        title: '每日虚拟电话权益上限',
                        dataIndex: 'reach_nbr',
                        key: 'reach_nbr',
                        width: 150,
                    },
                    {
                        title: '关注公司数量',
                        dataIndex: 'attention_company_nbr',
                        key: 'attention_company_nbr',
                        width: 100,
                    },
                    // 这里有变更
                    {
                        title: '立即沟通(月配额)',
                        dataIndex: 'direct_oppo_monthly',
                        key: 'direct_oppo_monthly',
                        width: 150,
                    },
                    {
                        title: '加好友(月配额)',
                        dataIndex: 'add_fr_monthly',
                        key: 'add_fr_monthly',
                        width: 150,
                    },
                    {
                        title: '团队虚拟电话剩余(年配额)',
                        dataIndex: 'reach_nbr_new_left',
                        key: 'reach_nbr_new_left',
                        width: 150,
                    },
                    {
                        title: '团队立即沟通剩余(年配额)',
                        dataIndex: 'direct_oppo_left',
                        key: 'direct_oppo_left',
                        width: 150,
                    },
                ]}
            />
        );
    };
    const renderWorkBenchInfo = () => {
        return (
            <TableLv2<ITalentWorkBenchData>
                loading={talentWorkBenchLoading}
                dataSource={talentWorkBenchData}
                closeRowSelection={true}
                pagination={false}
                className={'talent-member-data-table'}
                // pagination={{
                //     ...defaultMemberListPagination.paginationForUI,
                //     total: defaultMemberListPagination.amount,
                //     showSizeChanger: false,
                // }}
                // onPaginationChange={
                //     defaultMemberListPagination.setPaginationByUI
                // }
                scroll={{ x: '2000', y: '500' }}
                isFixedActions={false}
                columns={[
                    {
                        title: '企业号版本',
                        key: 'sale_type',
                        dataIndex: 'sale_type',
                        width: '120px',
                        render: v => {
                            const saleTypeMap = {
                                0: '基础门户版',
                                1: '招聘加速版',
                                2: '口碑版',
                            } as Record<number, string>;
                            return saleTypeMap[v] || '';
                        },
                    },
                    {
                        title: '是否为免费版',
                        key: 'is_sale_free',
                        dataIndex: 'is_sale_free',
                        width: '120px',
                        render: v => {
                            if (v == 0) {
                                return '付费版';
                            } else {
                                return '免费版';
                            }
                        },
                    },
                    {
                        title: '到期时间',
                        key: 'expire_time',
                        width: '120px',
                        dataIndex: 'expire_time',
                    },
                    {
                        title: '管理员（手机号）',
                        key: 'admin',
                        width: '200px',
                        render: (item: ITalentWorkBenchData) => {
                            return item.admin_list
                                ? item.admin_list.map(v => {
                                      return (
                                          <p
                                              className={'work-bench-admin'}
                                              key={v.id}
                                          >
                                              {`${v.realname}（${v.mobile}）`}{' '}
                                              {v.mobile ? (
                                                  <Icon
                                                      onClick={() => {
                                                          tryNewCall(
                                                              v.mobile,
                                                              true,
                                                              {
                                                                  customerName:
                                                                      props.defaultCustomerName,
                                                                  customerId:
                                                                      props.crm_id,
                                                                  userName:
                                                                      v.realname,
                                                                  showFollowLog: true,
                                                              },
                                                          );
                                                      }}
                                                      style={{
                                                          cursor: 'pointer',
                                                          display: 'inline',
                                                      }}
                                                      type="phone"
                                                      theme="twoTone"
                                                      twoToneColor="#0052ff"
                                                  />
                                              ) : null}
                                          </p>
                                      );
                                  })
                                : null;
                        },
                    },
                    {
                        title: '曝光币余额',
                        key: 'exposure_coins',
                        dataIndex: 'exposure_coins',
                        width: '90px',
                    },
                    {
                        title: '雇主口碑关键词数',
                        key: 'opinion_words_num',
                        dataIndex: 'opinion_words_num',
                        width: '120px',
                    },
                    {
                        title: '员工认证',
                        dataIndex: 'auth_employee_authentication',
                        key: 'auth_employee_authentication',
                        width: '80px',
                        render: (v, item) => {
                            return v === 0 ? '不开通' : '开通';
                        },
                    },
                    {
                        title: '员工可以聊',
                        dataIndex: 'auth_can_talk',
                        key: 'auth_can_talk',
                        width: '80px',
                        render: (v, item) => {
                            return v === 0 ? '不开通' : '开通';
                        },
                    },
                    {
                        title: '问员工',
                        dataIndex: 'auth_asking',
                        key: 'auth_asking',
                        width: '80px',
                        render: (v, item) => {
                            return v === 0 ? '不开通' : '开通';
                        },
                    },
                    {
                        title: '投诉降权',
                        dataIndex: 'complaint_num',
                        key: 'complaint_num',
                        width: '90px',
                    },
                    {
                        title: '内推职位',
                        dataIndex: 'internal_position_num',
                        key: 'internal_position_num',
                        width: '90px',
                    },
                ]}
            />
        );
    };

    const renderTookerInfo = () => {
        return (
            <TableLv2
                loading={talentTookerLoading}
                dataSource={talentTookerData}
                closeRowSelection={true}
                pagination={false}
                className={'talent-member-data-table'}
                // pagination={{
                //     ...defaultMemberListPagination.paginationForUI,
                //     total: defaultMemberListPagination.amount,
                //     showSizeChanger: false,
                // }}
                // onPaginationChange={
                //     defaultMemberListPagination.setPaginationByUI
                // }
                scroll={{ x: '2000', y: '500' }}
                isFixedActions={false}
                columns={[
                    {
                        title: '公司名称',
                        key: 'company',
                        dataIndex: 'company',
                        width: 120,
                    },
                    {
                        title: '团队ID',
                        key: 'license_id',
                        dataIndex: 'license_id',
                        width: 100,
                    },
                    {
                        title: '加好友余额',
                        key: 'addfr_cnt',
                        dataIndex: 'addfr_cnt',
                        width: 100,
                    },
                    {
                        title: '极速联系余额',
                        key: 'uh_cnt',
                        dataIndex: 'uh_cnt',
                        width: 100,
                    },
                    {
                        title: '席位数量',
                        key: 'sub_license',
                        dataIndex: 'sub_license',
                        width: 100,
                    },
                    {
                        title: '电话数量',
                        key: 'telephone_cnt',
                        dataIndex: 'telephone_cnt',
                        width: 100,
                    },
                    {
                        title: '脉客券数量',
                        key: 'promote_cnt',
                        dataIndex: 'promote_cnt',
                        width: 100,
                    },
                    {
                        title: '电话直连数量',
                        key: 'direct_mobile_cnt',
                        dataIndex: 'direct_mobile_cnt',
                        width: 100,
                    },
                    {
                        title: '是否基础版',
                        key: 'is_sale',
                        dataIndex: 'is_sale',
                        width: 100,
                        render: (v: number) => {
                            return v ? '是' : '否';
                        },
                    },
                    {
                        title: '批量功能子账号',
                        key: 'is_batch',
                        dataIndex: 'is_batch',
                        width: 100,
                    },
                    {
                        title: '是否营销',
                        key: 'is_market',
                        dataIndex: 'is_market',
                        width: 100,
                        render: (v: number) => {
                            return v ? '是' : '否';
                        },
                    },
                    {
                        title: '到期时间',
                        key: 'expire_time',
                        dataIndex: 'expire_time',
                        width: 100,
                    },
                ]}
            />
        );
    };

    const dateRangeValue: any = [
        useDataFilter?.start ? moment(useDataFilter?.start) : undefined,
        useDataFilter?.end ? moment(useDataFilter.end) : undefined,
    ];
    return (
        <>
            <NewReportDrawer
                cid={props.cid!}
                customerName={props.defaultCustomerName}
                teamData={talentMemberData}
                visible={newReportDrawerVisible}
                onClose={handleNewReportDrawerClose}
                onSubmit={handleNewReportSubmit}
                loading={newReportLoading}
                initialData={reportCopySeed}
            />
            <NewEmployerReportModal
                cid={props.cid!}
                customerName={props.defaultCustomerName}
                visible={newEmployerReportVisible}
                onClose={closeNewEmployerReportModal}
                onSubmit={handleNewEmployerReportSubmit}
                loading={newEmployerReportLoading}
            />
            <div className="customer-mai-rights-content">
                <Radio.Group
                    value={maiRightsSwitch}
                    onChange={e => {
                        setMaiRightsSwitch(e.target.value);
                    }}
                    style={{
                        marginTop: '10px',
                    }}
                >
                    <Radio.Button value="1">人才银行</Radio.Button>
                    <Radio.Button value="2">企业号</Radio.Button>
                    <Radio.Button value="3">拓客通</Radio.Button>
                </Radio.Group>
                <div className="mai-rights-inner-content">
                    <div className="mai-rights-item">
                        <p className="mai-rights-title">
                            基础合作信息
                            {/* {maiRightsSwitch == '1' ? (
                            <Button
                                onClick={() => {
                                    const url = `${window.location.origin}/bff/api/rest/member-list/export-customer-member-list?cid=${props.cid}`;
                                    window.open(url, '_blank');
                                }}
                                size={'small'}
                            >
                                导出
                            </Button>
                        ) : null} */}
                        </p>
                        {maiRightsSwitch === '1' && renderMemberListTable()}
                        {maiRightsSwitch === '2' && renderWorkBenchInfo()}
                        {maiRightsSwitch === '3' && renderTookerInfo()}
                    </div>

                    {maiRightsSwitch == '1' && (
                        <div className="mai-rights-item">
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <p className="mai-rights-title">客户复盘报告</p>
                                <div style={{ display: 'flex', gap: '10px' }}>
                                    <Icon
                                        type="reload"
                                        style={{
                                            fontSize: '16px',
                                            cursor: 'pointer',
                                            color: '#1890ff',
                                            lineHeight: '36px',
                                        }}
                                        onClick={() =>
                                            refreshCustomerRaskListAsync?.()
                                        }
                                        title="刷新表格"
                                    />
                                    <AntButton
                                        type="primary"
                                        onClick={() =>
                                            openNewReportDrawer(null)
                                        }
                                    >
                                        新增报告
                                    </AntButton>
                                </div>
                            </div>
                            <TableLv2<any>
                                loading={customerRaskListLoading}
                                dataSource={customerRaskList}
                                closeRowSelection={true}
                                pagination={false}
                                className={'talent-member-data-table'}
                                // pagination={{
                                //     ...defaultMemberListPagination.paginationForUI,
                                //     total: defaultMemberListPagination.amount,
                                //     showSizeChanger: false,
                                // }}
                                // onPaginationChange={
                                //     defaultMemberListPagination.setPaginationByUI
                                // }
                                scroll={{ x: '2000', y: '500' }}
                                isFixedActions={false}
                                columns={[
                                    {
                                        title: '报告名称',
                                        key: 'report_name',
                                        dataIndex: 'report_name',
                                        width: 260,
                                    },
                                    {
                                        title: '复盘公司CID',
                                        key: 'cid',
                                        dataIndex: 'cid',
                                        width: 120,
                                    },
                                    {
                                        title: '复盘团队',
                                        key: 'co_names',
                                        dataIndex: 'co_names',
                                        width: 300,
                                    },
                                    {
                                        title: '复盘时间周期',
                                        key: 'start_date',
                                        dataIndex: 'start_date',
                                        width: 200,
                                        render: (v, record) => {
                                            return `${v}至${record.end_date}`;
                                        },
                                    },
                                    {
                                        title: '对比时间周期',
                                        key: 'cmp_start_date',
                                        dataIndex: 'cmp_start_date',
                                        width: 200,
                                        render: (v, record) => {
                                            return `${v}至${record.cmp_end_date}`;
                                        },
                                    },
                                    {
                                        title: '竞对公司',
                                        key: 'competing_company',
                                        dataIndex: 'competing_company',
                                        width: 220,
                                        render: v => {
                                            return v?.join('，');
                                        },
                                    },
                                    {
                                        title: '职位',
                                        key: 'position_names',
                                        dataIndex: 'position_names',
                                        width: 160,
                                    },
                                    {
                                        title: '创建时间',
                                        key: 'crtime',
                                        dataIndex: 'crtime',
                                        width: 160,
                                    },
                                    {
                                        title: '状态',
                                        key: 'task_status',
                                        dataIndex: 'task_status',
                                        width: 100,
                                        render: (v, record) => {
                                            // 0-待处理；1-执行中；2-查询成功；3-查询失败；4-查询终止
                                            const statusMap = {
                                                0: {
                                                    text: '待处理',
                                                    color: undefined,
                                                },
                                                1: {
                                                    text: '执行中',
                                                    color: 'blue',
                                                },
                                                2: {
                                                    text: '查询成功',
                                                    color: 'green',
                                                },
                                                3: {
                                                    text: '查询失败',
                                                    color: 'red',
                                                },
                                                4: {
                                                    text: '查询终止',
                                                    color: 'orange',
                                                },
                                            } as Record<
                                                number,
                                                {
                                                    text: string;
                                                    color: string | undefined;
                                                }
                                            >;
                                            const status = statusMap[v];

                                            if (!status) {
                                                return '';
                                            }
                                            return (
                                                <Tag color={status.color}>
                                                    {status.text}
                                                </Tag>
                                            );
                                        },
                                    },
                                ]}
                                actions={[
                                    {
                                        actionKey: 'stop',
                                        actionCn: '终止',
                                        status: {
                                            disabled: item => {
                                                return ![0, 1].includes(
                                                    Number(item.task_status),
                                                );
                                            },
                                        },
                                    },
                                    {
                                        actionKey: 'view',
                                        actionCn: '查看',
                                        status: {
                                            disabled: item => {
                                                return item.task_status !== 2;
                                            },
                                        },
                                    },
                                    {
                                        actionKey: 'download',
                                        actionCn: '下载',
                                        status: {
                                            disabled: item => {
                                                return item.task_status !== 2;
                                            },
                                        },
                                    },
                                    {
                                        actionKey: 'copy',
                                        actionCn: '复制',
                                    },
                                ]}
                                actionsWidth={180}
                                onAction={(key, data) => {
                                    if (key === 'copy') {
                                        console.log('handleCopyReport', data);
                                        handleCopyReport(data);
                                        return;
                                    }
                                    if (key === 'stop') {
                                        handleStopCustomerTask(data);
                                    }
                                    if (key === 'view') {
                                        data.attach_url &&
                                            window.open(
                                                data.attach_url,
                                                '_blank',
                                            );
                                    }
                                    if (key === 'download') {
                                        data.file_pdf_url &&
                                            window.open(
                                                data.file_pdf_url,
                                                '_blank',
                                            );
                                    }
                                }}
                            />
                        </div>
                    )}

                    {maiRightsSwitch == '2' && (
                        <div className="mai-rights-item">
                            <div className="report-block-header">
                                <p className="mai-rights-title">
                                    雇主数据分析报告
                                </p>
                                <div className="report-block-actions">
                                    <Icon
                                        type="reload"
                                        style={{
                                            fontSize: '16px',
                                            cursor: 'pointer',
                                            color: '#1890ff',
                                            lineHeight: '36px',
                                        }}
                                        onClick={() =>
                                            refreshEmployerReportListAsync?.()
                                        }
                                        title="刷新表格"
                                    />
                                    <AntButton
                                        type="primary"
                                        onClick={openNewEmployerReportModal}
                                    >
                                        新增报告
                                    </AntButton>
                                </div>
                            </div>
                            <TableLv2<any>
                                loading={employerReportListLoading}
                                dataSource={
                                    Array.isArray(employerReportList)
                                        ? employerReportList
                                        : []
                                }
                                closeRowSelection={true}
                                pagination={false}
                                className={'talent-member-data-table'}
                                scroll={{ x: '2000', y: '500' }}
                                isFixedActions={false}
                                columns={[
                                    {
                                        title: '报告ID',
                                        key: 'report_id',
                                        width: 120,
                                        render: (_v, record) => record.id,
                                    },
                                    {
                                        title: '报告名称',
                                        key: 'report_name',
                                        width: 260,
                                        render: (_v, record) =>
                                            record.report_name,
                                    },
                                    {
                                        title: '复盘公司CID',
                                        key: 'cid',
                                        width: 120,
                                        render: (_v, record) => record.cid,
                                    },
                                    {
                                        title: '复盘时间周期',
                                        key: 'review_period',
                                        width: 220,
                                        render: (_v, record) =>
                                            record.start_date && record.end_date
                                                ? `${record.start_date}至${record.end_date}`
                                                : '',
                                    },
                                    {
                                        title: '对比时间周期',
                                        key: 'cmp_period',
                                        width: 220,
                                        render: (_v, record) =>
                                            record.cmp_start_date &&
                                            record.cmp_end_date
                                                ? `${record.cmp_start_date}至${record.cmp_end_date}`
                                                : '',
                                    },
                                    {
                                        title: '竞对公司',
                                        key: 'cmp_companies',
                                        width: 260,
                                        render: (_v, record) => {
                                            if (
                                                Array.isArray(
                                                    record.competing_company,
                                                )
                                            ) {
                                                return record.competing_company.join(
                                                    '，',
                                                );
                                            }
                                            return '';
                                        },
                                    },
                                    {
                                        title: '创建时间',
                                        key: 'crtime',
                                        width: 170,
                                        render: (_v, record) => record.crtime,
                                    },
                                    {
                                        title: '状态',
                                        key: 'task_status',
                                        width: 100,
                                        render: (_v, record) => {
                                            const meta = getEmployerTaskStatusMeta(
                                                record.task_status,
                                            );
                                            return (
                                                <Tag color={meta.color}>
                                                    {meta.text}
                                                </Tag>
                                            );
                                        },
                                    },
                                ]}
                                actions={[
                                    {
                                        actionKey: 'stop',
                                        actionCn: '终止',
                                        status: {
                                            disabled: item => {
                                                const meta = getEmployerTaskStatusMeta(
                                                    item.task_status,
                                                );
                                                return ![
                                                    'created',
                                                    'running',
                                                ].includes(meta.code);
                                            },
                                        },
                                    },
                                    {
                                        actionKey: 'download',
                                        actionCn: '下载',
                                        status: {
                                            disabled: item => {
                                                const meta = getEmployerTaskStatusMeta(
                                                    item.task_status,
                                                );
                                                return (
                                                    meta.code !== 'completed'
                                                );
                                            },
                                        },
                                    },
                                ]}
                                onAction={(key, data) => {
                                    if (key === 'stop') {
                                        handleStopEmployerTask(data);
                                        return;
                                    }
                                    if (key === 'download') {
                                        const downloadUrl = data?.file_path;
                                        if (downloadUrl) {
                                            window.open(
                                                String(downloadUrl),
                                                '_blank',
                                            );
                                        } else {
                                            message.warning('暂无可下载文件');
                                        }
                                    }
                                }}
                            />
                        </div>
                    )}

                    {maiRightsSwitch == '1' && (
                        <RightsReportDetail
                            teamAdminData={teamAdminData}
                            teamAdminLoading={talentLoading}
                        />
                    )}

                    {maiRightsSwitch == '1' ? (
                        <div className="mai-rights-item">
                            <p className="mai-rights-title">
                                团队使用数据-累计数据
                                <a
                                    style={{
                                        fontSize: '12px',
                                        position: 'absolute',
                                        left: '180px',
                                    }}
                                    target="_blank"
                                    href="https://maimai.feishu.cn/wiki/wikcn7fU3i2ntx0B1Z29xs3czCe?sheet=0PGSHZ"
                                >
                                    <Icon
                                        style={{
                                            marginRight: '2px',
                                        }}
                                        type="question-circle"
                                    />
                                    口径说明
                                </a>
                            </p>
                            <div className="mai-rights-filter">
                                <div className="mai-rights-filter-item">
                                    <span className="mai-rights-filter-label">
                                        团队管理员
                                    </span>
                                    <Select
                                        loading={talentLoading}
                                        value={useDataFilter?.teamAdmin}
                                        onChange={(value: any) => {
                                            setUseDataFilter({
                                                ...useDataFilter,
                                                teamAdmin: value,
                                            });
                                        }}
                                        style={{
                                            width: '150px',
                                        }}
                                        dropdownMatchSelectWidth={false}
                                    >
                                        {_.map(teamAdminData, item => {
                                            return (
                                                <Select.Option
                                                    value={item.id}
                                                    // className={`cid-${item.id}`}
                                                >{`${item.name}-${item.phone}`}</Select.Option>
                                            );
                                        })}
                                    </Select>
                                </div>
                                <div className="mai-rights-filter-item">
                                    <span className="mai-rights-filter-label">
                                        时间周期
                                    </span>
                                    <DatePicker.RangePicker
                                        value={dateRangeValue}
                                        // width={230}
                                        showTime={true}
                                        format="YYYY-MM-DD"
                                        onChange={dates => {
                                            setUseDataFilter({
                                                ...useDataFilter,
                                                start: dates[0]
                                                    ? dates[0].valueOf()
                                                    : undefined,
                                                end: dates[1]
                                                    ? dates[1].valueOf()
                                                    : undefined,
                                            });
                                        }}
                                        style={{ width: '230px' }}
                                        allowClear={false}
                                    />
                                </div>
                                <AntButton
                                    disabled={!useDataFilter?.teamAdmin}
                                    type="primary"
                                    onClick={fetchUseNewData}
                                >
                                    查询
                                </AntButton>
                                <AntButton
                                    disabled={!useDataFilter?.teamAdmin}
                                    onClick={exportUseNewData}
                                >
                                    导出
                                </AntButton>
                            </div>
                            <div style={{ marginBottom: '15px' }}>
                                <TableLv2
                                    closeRowSelection={true}
                                    className={'talent-member-data-table'}
                                    loading={useDataLoading}
                                    dataSource={useNewDataOrigin?.data?.map(
                                        item => {
                                            // 当前是否绑定 = 否 ：后4项资产剩余展示为 -
                                            const { asset } = item;
                                            if (asset) {
                                                const { bind_st = '' } = asset;
                                                if (bind_st === '否') {
                                                    for (let i in item.asset) {
                                                        if (i !== 'bind_st') {
                                                            item.asset[i] = '-';
                                                        }
                                                    }
                                                }
                                            }
                                            return item;
                                        },
                                    )}
                                    scroll={{
                                        x: 3000,
                                    }}
                                    pagination={{
                                        total: useNewDataOrigin?.total,
                                        pageSize: useDataPagination.pageSize,
                                    }}
                                    onPaginationChange={({
                                        current,
                                        pageSize,
                                    }) => {
                                        setUseDataPagination({
                                            current,
                                            pageSize: pageSize!,
                                        });
                                    }}
                                    columns={useNewDataOrigin?.titles?.map(
                                        title => ({
                                            title: title.name,
                                            children: title.sub_titles?.map(
                                                subTitle =>
                                                    subTitle.key === 'mobile'
                                                        ? {
                                                              title:
                                                                  subTitle.name,
                                                              dataIndex: `${title.key}.${subTitle.key}`,
                                                              width: '140px',
                                                              render: (
                                                                  v,
                                                                  r: any,
                                                              ) => {
                                                                  return v ? (
                                                                      <CC
                                                                          args={[
                                                                              r?.[
                                                                                  title
                                                                                      .key
                                                                              ]?.[
                                                                                  'emobile'
                                                                              ],
                                                                          ]}
                                                                          config={{
                                                                              customerId:
                                                                                  props.crm_id,
                                                                              customerName:
                                                                                  props.defaultCustomerName,
                                                                              userName:
                                                                                  r
                                                                                      .base_info
                                                                                      .lic_sub_name,
                                                                          }}
                                                                          isHidden={
                                                                              true
                                                                          }
                                                                          sceneCode="crm_customer"
                                                                          outerHiddenNumber={
                                                                              v
                                                                          }
                                                                      />
                                                                  ) : null;
                                                              },
                                                          }
                                                        : {
                                                              title:
                                                                  subTitle.name,
                                                              dataIndex: `${title.key}.${subTitle.key}`,
                                                          },
                                            ),
                                        }),
                                    )}
                                />
                            </div>

                            {/* <TableLv2
                            pagination={false}
                            closeRowSelection={true}
                            className={'talent-member-data-table'}
                            loading={useDataLoading}
                            dataSource={useDataOrigin}
                            scroll={{
                                x: 3000,
                            }}
                            columns={[
                                {
                                    title: 'license基础信息',
                                    children: [
                                        {
                                            title: '姓名',
                                            dataIndex: 'base.name',
                                        },
                                        {
                                            title: '手机',
                                            dataIndex: 'base.emobile',
                                            width: '140px',
                                            render: (v, r: any) => {
                                                return v ? (
                                                    <CC
                                                        args={[v]}
                                                        config={{
                                                            customerId:
                                                                props.crm_id,
                                                            customerName:
                                                                props.defaultCustomerName,
                                                        }}
                                                        isHidden={true}
                                                        sceneCode={
                                                            'crm_customer'
                                                        }
                                                        outerHiddenNumber={
                                                            r?.base
                                                                ?.emobile_star
                                                        }
                                                    />
                                                ) : null;
                                            },
                                        },
                                        {
                                            title: 'uid',
                                            dataIndex: 'base.uid',
                                        },
                                        {
                                            title: '身份',
                                            dataIndex: 'base.position',
                                        },
                                        {
                                            title: '会员开通日期',
                                            dataIndex: 'base.member_start_time',
                                        },
                                        {
                                            title: '累计会员在线天数',
                                            dataIndex: 'base.total_member_days',
                                        },
                                        {
                                            title: '加入会员时间',
                                            dataIndex: 'base.member_join_time',
                                        },
                                        {
                                            title: '立即沟通剩余量',
                                            dataIndex: 'base.direct_left',
                                        },
                                        {
                                            title: '虚拟电话剩余量',
                                            dataIndex:
                                                'base.virtual_phone_left',
                                        },
                                        {
                                            title: '加好友剩余量',
                                            dataIndex: 'base.friend_left',
                                        },
                                        {
                                            title: '点数剩余量（2.0）',
                                            dataIndex: 'base.coin_left',
                                        },
                                    ],
                                },
                                {
                                    title: '活跃程度',
                                    children: [
                                        {
                                            title: '脉脉活跃天数',
                                            dataIndex: 'active.mm_active_days',
                                        },
                                        {
                                            title: '招聘活跃天数(人才天数)',
                                            dataIndex:
                                                'active.recruitment_active_days',
                                        },
                                        {
                                            title: '累计招聘活跃度',
                                            dataIndex: 'active.active_rate',
                                        },
                                    ],
                                },
                                {
                                    title: '发现人才',
                                    children: [
                                        {
                                            title: '累计搜索次数',
                                            dataIndex:
                                                'find_talent.total_search_count',
                                        },
                                        {
                                            title: '累计候选人浏览量',
                                            dataIndex:
                                                'find_talent.total_talent_pv',
                                        },
                                    ],
                                },
                                {
                                    title: '连接人才',
                                    children: [
                                        {
                                            title: '立刻沟通发送量',
                                            dataIndex:
                                                'connection.direct_oppo_count',
                                        },
                                        {
                                            title: '立刻沟通回复量',
                                            dataIndex:
                                                'connection.direct_oppo_reply_count',
                                        },
                                        {
                                            title: '虚拟电话索要量',
                                            dataIndex:
                                                'connection.virtual_phone_request_count',
                                        },
                                        {
                                            title: '虚拟电话拨打量',
                                            dataIndex:
                                                'connection.virtual_phone_call_count',
                                        },
                                        {
                                            title: '虚拟电话接通量',
                                            dataIndex:
                                                'connection.virtual_phone_connected_count',
                                        },
                                        {
                                            title: '加好友量',
                                            dataIndex:
                                                'connection.friend_add_request_count',
                                        },
                                        {
                                            title: '加好友量通过量',
                                            dataIndex:
                                                'connection.friend_add_success_count',
                                        },
                                    ],
                                },
                                {
                                    title: '职位与简历',
                                    children: [
                                        {
                                            title: '新增职位数',
                                            dataIndex:
                                                'jobs_and_resume.new_jobs_count',
                                        },
                                        {
                                            title: '有效职位数',
                                            dataIndex:
                                                'jobs_and_resume.valid_jobs_count',
                                        },
                                        {
                                            title: '收简历',
                                            dataIndex:
                                                'jobs_and_resume.received_resume_count',
                                        },
                                        {
                                            title: '处理简历',
                                            dataIndex:
                                                'jobs_and_resume.handle_resume_count',
                                        },
                                        {
                                            title: '感兴趣简历',
                                            dataIndex:
                                                'jobs_and_resume.interest_resume_count',
                                        },
                                    ],
                                },
                            ]}
                        />
                        <AntButton
                            disabled={!useDataFilter?.teamAdmin}
                            onClick={exportUseData}
                        >
                            导出
                        </AntButton> */}
                        </div>
                    ) : (
                        undefined
                    )}
                    {maiRightsSwitch == '3' ? (
                        <div className="mai-rights-item">
                            <p className="mai-rights-title">
                                团队使用数据-累计数据
                                <a
                                    style={{
                                        fontSize: '12px',
                                        position: 'absolute',
                                        left: '180px',
                                    }}
                                    target="_blank"
                                    href="https://maimai.feishu.cn/wiki/Oh0Uwj0tDiisznkXiLjcATnWnLh"
                                >
                                    <Icon
                                        style={{
                                            marginRight: '2px',
                                        }}
                                        type="question-circle"
                                    />
                                    口径说明
                                </a>
                            </p>
                            <div className="mai-rights-filter">
                                <div className="mai-rights-filter-item">
                                    <span className="mai-rights-filter-label">
                                        团队
                                    </span>
                                    <Select
                                        value={tktFilter?.licenseId}
                                        onChange={(value: any) => {
                                            setTktFilter({
                                                ...tktFilter,
                                                licenseId: value,
                                            });
                                        }}
                                        style={{
                                            width: '150px',
                                        }}
                                        dropdownMatchSelectWidth={false}
                                    >
                                        {teamInfoData?.map(item => (
                                            <Select.Option
                                                value={item.license_id}
                                            >{`${item.license_id}-${item.name ||
                                                item.realname ||
                                                ''}-${item.phone ||
                                                item.mobile ||
                                                ''}`}</Select.Option>
                                        ))}
                                    </Select>
                                </div>
                                <div className="mai-rights-filter-item">
                                    <span className="mai-rights-filter-label">
                                        时间周期
                                    </span>
                                    <DatePicker.RangePicker
                                        value={
                                            [
                                                tktFilter?.start
                                                    ? moment(tktFilter?.start)
                                                    : undefined,
                                                tktFilter?.end
                                                    ? moment(tktFilter?.end)
                                                    : undefined,
                                            ] as any
                                        }
                                        // width={230}
                                        showTime={true}
                                        format="YYYY-MM-DD"
                                        onChange={dates => {
                                            setTktFilter({
                                                ...tktFilter,
                                                start: dates[0]
                                                    ? dates[0].valueOf()
                                                    : undefined,
                                                end: dates[1]
                                                    ? dates[1].valueOf()
                                                    : undefined,
                                            });
                                        }}
                                        style={{ width: '230px' }}
                                        allowClear={false}
                                    />
                                </div>
                                <AntButton
                                    disabled={!tktFilter?.licenseId}
                                    type="primary"
                                    onClick={fetchTktUseNewData}
                                >
                                    查询
                                </AntButton>
                                <AntButton
                                    disabled={!tktUseDataOrigin?.data?.length}
                                    onClick={() =>
                                        exportTktUseNewDataXlsx(
                                            tktUseDataOrigin,
                                        )
                                    }
                                >
                                    导出
                                </AntButton>
                            </div>
                            <div style={{ marginBottom: '15px' }}>
                                <TableLv2
                                    closeRowSelection={true}
                                    className={'talent-member-data-table'}
                                    loading={tktUseDataLoading}
                                    dataSource={tktUseDataOrigin?.data}
                                    scroll={{
                                        x: 3000,
                                    }}
                                    pagination={false}
                                    columns={tktUseDataOrigin?.titles?.map(
                                        (title: any) => ({
                                            title: title.name,
                                            children: title.sub_titles?.map(
                                                (subTitle: any) => ({
                                                    title: subTitle.name,
                                                    dataIndex: `${title.key}.${subTitle.key}`,
                                                    render: (
                                                        v: any,
                                                        r: any,
                                                    ) => {
                                                        const camelKey = _.camelCase(
                                                            subTitle.key,
                                                        );
                                                        const nested = _.get(
                                                            r,
                                                            `${title.key}.${subTitle.key}`,
                                                        );
                                                        return (
                                                            nested ??
                                                            r[subTitle.key] ??
                                                            r[camelKey] ??
                                                            v ??
                                                            '-'
                                                        );
                                                    },
                                                }),
                                            ),
                                        }),
                                    )}
                                />
                            </div>
                            <div>
                                <p className="mai-rights-title">
                                    团队使用数据-累计数据V2
                                    <AntButton
                                        disabled={
                                            !tktUseDataV2Origin?.data?.length
                                        }
                                        onClick={() =>
                                            exportTktUseDataV2Xlsx(
                                                tktUseDataV2Origin,
                                            )
                                        }
                                    >
                                        导出
                                    </AntButton>
                                </p>
                                <div style={{ marginBottom: '15px' }}>
                                    <TableLv2
                                        closeRowSelection={true}
                                        className="talent-member-data-table"
                                        loading={tktUseDataV2Loading}
                                        dataSource={tktUseDataV2Origin?.data || []}
                                        scroll={{ x: 1800 }}
                                        pagination={false}
                                        columns={tktUseDataV2Origin?.titles?.map(
                                            (title: any) => ({
                                                title: title.name,
                                                dataIndex: title.key,
                                                render: (value: any) =>
                                                    value ?? '-',
                                            }),
                                        )}
                                    />
                                </div>
                            </div>
                        </div>
                    ) : (
                        undefined
                    )}
                </div>
            </div>
        </>
    );
};

export default observer(CustomerMaiRights);
